/**
 * Map presets (UI data, Phase 2) — deterministic gimmick layouts.
 *
 * Pure data + helpers, no three.js / DOM dependency (node-testable).
 * Design constraints (fairness):
 *   - Every layout is point-symmetric about the board center (4,4):
 *     for each gimmick at (c, r) there is one of the same type at
 *     (8-c, 8-r). Both players therefore face an identical landscape.
 *   - Never on the starting cells (4,0) / (4,8).
 *   - Density per map: 6–14 gimmick tiles.
 *
 * Coordinates use the core convention: { col, row } on a 9x9 board.
 */

const ice = (col, row) => ({ type: 'ice', col, row });
const swamp = (col, row) => ({ type: 'swamp', col, row });

export const PRESETS = [
  {
    id: 'classic',
    name: 'クラシック',
    description: 'ギミックなしの標準盤。',
    gimmicks: [],
  },
  {
    id: 'ice-corridor',
    name: '氷の回廊',
    description:
      '盤中央に氷の帯。進入すると進入方向へ滑り、壁・駒・盤端か氷でないマスで停止。',
    // 11 ice tiles across the central band (rows 3–5), point-symmetric.
    gimmicks: [
      ice(2, 3), ice(4, 3), ice(6, 3),
      ice(1, 4), ice(3, 4), ice(4, 4), ice(5, 4), ice(7, 4),
      ice(2, 5), ice(4, 5), ice(6, 5),
    ],
  },
  {
    id: 'swampland',
    name: '沼地',
    description:
      '沼が点在。移動して止まると次の自分のターンは駒を動かせない（壁設置は可）。',
    // 8 swamp tiles scattered in point-symmetric pairs.
    gimmicks: [
      swamp(2, 2), swamp(6, 2),
      swamp(4, 3), swamp(7, 3),
      swamp(1, 5), swamp(4, 5),
      swamp(2, 6), swamp(6, 6),
    ],
  },
  {
    id: 'ice-and-swamp',
    name: '氷と沼',
    description: '中央の氷の帯と、四方の沼の混合マップ。',
    // 5 ice (central row) + 4 swamp (corner quads) = 9 tiles.
    gimmicks: [
      ice(2, 4), ice(3, 4), ice(4, 4), ice(5, 4), ice(6, 4),
      swamp(2, 2), swamp(6, 2),
      swamp(2, 6), swamp(6, 6),
    ],
  },
];

/** Preset by id; falls back to the classic (no-gimmick) preset. */
export function presetById(id) {
  return PRESETS.find((p) => p.id === id) ?? PRESETS[0];
}
